<template>
  <CardBase card-title="Desculpe, estamos passando por uma instabilidade no sistema">
    <template #header>
      <img src="@/assets/images/homem-duvida.svg" alt="" class="image">
    </template>

    <p class="message">
      {{ message }}
    </p>

    <template #footer>
      <router-link v-slot="{ href, navigate }" to="/" custom>
        <a :href="href" class="button" @click="navigate($event).finally(() => $emit('retry'))">
          {{ buttonText }}
        </a>
      </router-link>
    </template>
  </CardBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import CardBase from '@/components/CardBase.vue';
import { acertoAcessouCardErro } from '@/modules/events/acerto';

export default defineComponent({
  components: { CardBase },
  props: {
    message: {
      type: String,
      default: 'Tente novamente enquanto resolvemos o problema',
    },
    buttonText: {
      type: String,
      default: 'Tentar novamente',
    },
    componentePai: {
      type: String,
      required: true,
    },
  },
  emits: ['retry'],
  mounted() {
    acertoAcessouCardErro(globalThis.location.href, this.componentePai);
  },
});
</script>

<style scoped lang="scss">
.image {
  height: 144px;
}

.message {
  color: #131416;
  font-size: 0.875rem;
  line-height: 1.5;
}

.button {
  display: block;
  width: 100%;
}
</style>
